// extracted by mini-css-extract-plugin
export default {"image":"ApartmentCardMedia_image__Y+1u-","reelsView":"ApartmentCardMedia_reelsView__xb590","placeholder":"ApartmentCardMedia_placeholder__h4y2C"};